(function () {
  const storageKey = 'coffeehaus:favorites';

  function readFavorites() {
    try {
      const value = JSON.parse(localStorage.getItem(storageKey) || '[]');
      return Array.isArray(value) ? value : [];
    } catch (error) {
      return [];
    }
  }

  function writeFavorites(items) {
    localStorage.setItem(storageKey, JSON.stringify(items));
    window.dispatchEvent(new CustomEvent('haus:favorites-updated', { detail: { items } }));
  }

  function findFavorite(handle) {
    return readFavorites().find((item) => item.handle === handle);
  }

  function updateButton(button, active) {
    button.classList.toggle('is-active', active);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
    button.setAttribute('aria-label', active ? 'Favorilerden çıkar' : 'Favorilere ekle');
  }

  function syncButtons() {
    const favorites = readFavorites();
    document.querySelectorAll('[data-haus-favorite]').forEach((button) => {
      updateButton(button, favorites.some((item) => item.handle === button.dataset.productHandle));
    });
  }

  function getProductData(button) {
    return {
      handle: button.dataset.productHandle,
      title: button.dataset.productTitle,
      url: button.dataset.productUrl,
      image: button.dataset.productImage,
      price: button.dataset.productPrice,
      comparePrice: button.dataset.productComparePrice,
      vendor: button.dataset.productVendor,
      variantId: button.dataset.variantId,
    };
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-haus-favorite]');
    if (!button) return;

    event.preventDefault();
    const product = getProductData(button);
    if (!product.handle) return;

    const favorites = readFavorites();
    const existingIndex = favorites.findIndex((item) => item.handle === product.handle);

    if (existingIndex >= 0) {
      favorites.splice(existingIndex, 1);
    } else {
      favorites.unshift(product);
    }

    writeFavorites(favorites);
    syncButtons();
  });

  window.CoffeehausFavorites = {
    all: readFavorites,
    has: (handle) => Boolean(findFavorite(handle)),
    sync: syncButtons,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncButtons);
  } else {
    syncButtons();
  }

  window.addEventListener('storage', (event) => {
    if (event.key === storageKey) syncButtons();
  });
})();
 